import React, { useState, useCallback } from 'react';
import { Button } from '@pushpay/button';
import { LoadingOvalIcon, ClockIcon } from '@pushpay/iconography';
import { clsx } from '@pushpay/styles';
import ExportTitle from './export-title';
import useSharedStyles from './use-styles';

const QueuedJob = props => {
  const {
    classes: classesProp,
    'data-pp-at-target': targetId,
    job,
    onCancel,
    translate
  } = props;
  const {
    jobKey,
    filename,
    isNew,
    type,
    createdOn,
    customSubtext,
    customTitle
  } = job;
  const sharedClasses = useSharedStyles(classesProp);
  const [isCancelling, setIsCancelling] = useState(false);
  const handleCancel = useCallback(() => {
    setIsCancelling(true);
    onCancel(jobKey);
  }, [job, onCancel]);
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(sharedClasses.itemRoot, isNew ? sharedClasses.newItem : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.itemStatusIconContainer
  }, /*#__PURE__*/React.createElement(ClockIcon, {
    className: sharedClasses.queuedArrowIcon,
    "data-pp-at-target": `${targetId}-arrow-icon`
  })), /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.itemMainInfoWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.itemMainInfo
  }, /*#__PURE__*/React.createElement("div", {
    title: filename !== null && filename !== void 0 ? filename : '',
    className: sharedClasses.itemFileName
  }, customTitle && typeof customTitle === 'function' ? customTitle(jobKey, type, createdOn, filename, isNew) : customTitle && /*#__PURE__*/React.createElement(ExportTitle, {
    titleText: customTitle.titleText,
    titleSubtext: customTitle.titleSubtext,
    "data-pp-at-target": `${targetId}-queued-custom-export-title`
  }) || filename), /*#__PURE__*/React.createElement("div", {
    className: clsx(sharedClasses.subText, sharedClasses.subTextInQueued)
  }, customSubtext && typeof customSubtext === 'function' ? customSubtext(jobKey, type, createdOn, filename, isNew) : !!customSubtext && customSubtext || translate('downloadsPanel.exportInQueue')))), /*#__PURE__*/React.createElement("div", {
    className: sharedClasses.itemActionWrap
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleCancel,
    disabled: isCancelling,
    type: "button",
    displayStyle: "text",
    "data-pp-at-target": `${targetId}-cancel-btn`
  }, translate(isCancelling ? 'downloadsPanel.cancelling' : 'downloadsPanel.cancel'), isCancelling && /*#__PURE__*/React.createElement(LoadingOvalIcon, {
    className: sharedClasses.btnLoadingSpinner,
    "data-pp-at-target": `${targetId}-loading-icon`
  }))));
};

export default QueuedJob;